import {atom} from 'jotai';

const modalMovedAtom = atom(false);

/* 阻止数据变化没保存就跳转页面 */
const blockRouterAtom = atom(false);

export {modalMovedAtom, blockRouterAtom};
